<template>
  <div id="app">
    <router-view></router-view>
    <loading></loading>
  </div>
</template>

<script>
import loading from './components/loading.vue'
export default {
  name: 'App',
  components: {
    loading
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  data(){
    return{
      showHeader:true,
      isRouterAlive: true
    }
  },
  computed:{
   
  },
  created(){

   
  },
  methods:{
    reload () {
      this.isRouterAlive = false
      let that = this
      this.$nextTick(function () {
        that.isRouterAlive = true
      })
    }
  },
  watch:{
    '$route':{
      handler(router){
        if(router.path == '/index'){
          this.$store.state.isFloat = false 
          this.showHeader = true
        }else{
          this.showHeader = true
          this.$store.state.isFloat = true
          if(router.path == '/login' || router.path == '/signup'){
            this.showHeader = false
          }
        }
       
      }
      
    }
  }
  
}
</script>

<style lang="scss" >
#app {
  // font-family: Chunk Five;
  font-family: Poppins, Poppins;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  font-weight: bold;
  background:$theme_bg;
  display: flex;
  flex-direction: column;
  color:#fff;
  min-height: 100vh;
  overflow: hidden;
  // width: 100vw;
}

* {
  margin: 0;
  padding: 0;
}
</style>
